//TRUNCATE TEXT
export const truncateText = (text, maxLength = 10) => {
  let textTruncate =
    text?.length > maxLength ? text?.substring(0, maxLength) + '...' : text;

  return textTruncate;
};
